import { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import { initialSurchargeTrends } from "../constants";
import { buildBreakdownQuery } from "../formatters";

export function useQbrSurchargeTrends(filters, canLoadData) {
  const [surchargeTrends, setSurchargeTrends] = useState(initialSurchargeTrends);
  const [isTrendsLoading, setIsTrendsLoading] = useState(false);

  useEffect(() => {
    if (!canLoadData) {
      setSurchargeTrends(initialSurchargeTrends);
      return;
    }

    let cancelled = false;
    const controller = new AbortController();
    const params = buildBreakdownQuery(filters).toString();

    setIsTrendsLoading(true);
    setSurchargeTrends(initialSurchargeTrends);

    apiClient
      .get(`/api/v1/difotVisualisation/surcharge-trends?${params}`, { signal: controller.signal })
      .then(async (response) => {
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.detail || payload.error || "Failed to load surcharge trends");
        }
        return response.json();
      })
      .then((data) => {
        if (cancelled) return;
        setSurchargeTrends({
          dangerousGoods: data.dangerousGoods || initialSurchargeTrends.dangerousGoods,
          fuel: data.fuel || initialSurchargeTrends.fuel,
          residential: data.residential || initialSurchargeTrends.residential,
          totalSurcharge: data.totalSurcharge || initialSurchargeTrends.totalSurcharge,
        });
      })
      .catch((err) => {
        if (err.name === "AbortError" || cancelled) return;
      })
      .finally(() => {
        if (!cancelled) setIsTrendsLoading(false);
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [canLoadData, filters]);

  return { surchargeTrends, isTrendsLoading };
}
